/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon16Light = forwardRef('AttachPaperclipIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.07 2.571a2.888 2.888 0 1 1 4.085 4.085l-6.202 6.202A4.083 4.083 0 1 1 2.18 7.084l4.316-4.317a.5.5 0 1 1 .707.708L2.887 7.79a3.083 3.083 0 0 0 4.36 4.36l6.2-6.202a1.888 1.888 0 1 0-2.67-2.67L4.674 9.382a.694.694 0 0 0 .981.982l4.219-4.219a.5.5 0 1 1 .707.707l-4.218 4.219a1.694 1.694 0 0 1-2.396-2.396L10.07 2.57Z" })));
});
